import { CompanyEVP } from '../CompanyEVP/CompanyEVP';
import { RecommendedJobCard } from '../DashboardRecommendations/RecommendedJobCard';
import { RecsInterceptSurvey } from '../RecsInterceptSurvey/RecsInterceptSurvey';
import {
  isCareerFeedCompanyEvp,
  isCareerFeedJob,
  isCareerFeedRecsInterceptSurvey,
  type CareerFeedItem,
} from '../hooks/feed-types';

export const FEED_ITEMS_DATA_AUTOMATION = 'feedJobs';

type CareerFeedItemsProps = {
  feedItems: CareerFeedItem[];
};

const CareerFeedItem = ({
  feedItem,
  index,
}: {
  feedItem: CareerFeedItem;
  index: number;
}) => {
  if (isCareerFeedJob(feedItem)) {
    return (
      <RecommendedJobCard
        key={`recommendedJob_${feedItem.id}`}
        testAutomation={{
          jobCardLink: `recommendedJobLink_${feedItem.id}`,
        }}
        jobInfo={feedItem}
        position={index + 1}
        isFeaturedOrDisplayKeyType="feedJobs"
      />
    );
  }

  if (isCareerFeedRecsInterceptSurvey(feedItem)) {
    return <RecsInterceptSurvey />;
  }

  if (isCareerFeedCompanyEvp(feedItem)) {
    return <CompanyEVP {...feedItem} />;
  }

  return null;
};

export const CareerFeedItems: React.FC<CareerFeedItemsProps> = ({
  feedItems,
}) => (
  <div data-automation={FEED_ITEMS_DATA_AUTOMATION}>
    {feedItems.map((feedItem, index) => (
      <CareerFeedItem key={index} feedItem={feedItem} index={index} />
    ))}
  </div>
);
